import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
// import Settings from '../settings'

// This component has:
// 1. Video oEmbed

class SectionVideo extends Component {

   componentDidMount() {

   }

   render() {
      const {
         video_url = 'test'
      } = this.props.data

      const video_html = video_url.replace('width','Xwidth').replace('height','Xheight')

      return (
         <div className="SectionVideo">

            <div className={`page-width`}>
               <div className="embed-container">
                 <div className="embed-feather feather-rect"></div>
                 { ReactHtmlParser(video_html) }
               </div>
            </div>

         </div>
      )
   }
}

export default SectionVideo



// WEBPACK FOOTER //
// ./src/components/SectionVideo.js